export { default } from './Promis10Module';
